import karla400 from '@fontsource/karla/files/karla-latin-400-normal.woff2'
import karla500 from '@fontsource/karla/files/karla-latin-500-normal.woff2'
import karla600 from '@fontsource/karla/files/karla-latin-600-normal.woff2'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import App from './App'
import 'react-tippy/dist/tippy.css'
import '@fontsource/karla/latin-400.css'
import '@fontsource/karla/latin-500.css'
import '@fontsource/karla/latin-600.css'
import './index.css'

const root = createRoot(document.getElementById('root'))
const qc = new QueryClient()
root.render(
  <StrictMode>
    <HelmetProvider>
      <Helmet>
        <link rel="preload" href={karla400} as="font" type="font/woff2" crossorigin />
        <link rel="preload" href={karla500} as="font" type="font/woff2" crossorigin />
        <link rel="preload" href={karla600} as="font" type="font/woff2" crossorigin />
      </Helmet>
      <QueryClientProvider client={qc}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
)
